// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import jQuery from "jquery";
import ModulePreloader from "src/scripts/modules/modulePreloader";
import Tournament from "src/scripts/pages/tournament";
import Qualification from "src/scripts/pages/qualification";
import Home from "src/scripts/pages/home";
import Consent from "src/scripts/pages/consent";
import Textpage from "src/scripts/pages/textpage";

jQuery(document).ready(function () {
  let pageName = jQuery('body').data('page');

  const modulePreloader = new ModulePreloader();
  modulePreloader.init();

  setTimeout(function () {

    if(pageName == "home") {
      const home = new Home();
      home.init();
    }
    else if(pageName == "consent") {
      const consent = new Consent();
      consent.init();
    }
    else if(pageName == "qualification") {
      const qualification = new Qualification();
      qualification.init();
    }
    else if(pageName == "tournament") {
      const tournament = new Tournament();
      tournament.init();
    }
    else if(pageName == "text") {
      const textpage = new Textpage();
      textpage.init();
    }
  }, 100);
});
